import { render, staticRenderFns } from "./ProjectWlcmHomeCampaignOverview.vue?vue&type=template&id=8f0b8d42"
import script from "./ProjectWlcmHomeCampaignOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectWlcmHomeCampaignOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports